import Tibbit63Node from '@appblocks/codegeneration/Nodes/Tibbit63Node';
import { Setting, SettingType } from '@appblocks/codegeneration/types';

export default class Tibbit63_1Node extends Tibbit63Node {
    constructor() {
        super();
        this.name = 'Tibbit 63_1';
        this.id = 'node_tibbit_63_1';
        this.linkedFeature = 'general';
        this.description = 'AC Voltage Detector (110V)';

        const settings: Setting[] = [
            {
                id: 'TIBBIT',
                name: 'Tibbit',
                settingType: SettingType.OPTION,
                required: true,
                refId: 'tibbit_63_1',
                default: '',
            },
        ];

        this.settings = this.settings.concat(settings);
    }
}
